export default __webpack_public_path__ + "static/media/EricSmile400.f87836df.jpg";